// ─── Escalas de los gráficos del panel (puro) ───────────────────────────────
// Un solo modelo para los dos dibujantes: la pantalla (SVG) y los PDF de E
// (@react-pdf). Sin librería de gráficos: SVG propio (decisión del PM).

/** Escala lineal: lleva [d0, d1] a [r0, r1]. */
export const linear =
  (d0: number, d1: number, r0: number, r1: number) =>
  (v: number): number =>
    d1 === d0 ? r0 : r0 + ((v - d0) / (d1 - d0)) * (r1 - r0);

/** Escala de bandas: `n` categorías en [r0, r1], con `pad` de espacio entre ellas. */
export function band(n: number, r0: number, r1: number, pad = 0.2) {
  const step = n > 0 ? (r1 - r0) / n : 0;
  const width = step * (1 - pad);
  return {
    step,
    width,
    x: (i: number) => r0 + i * step + (step - width) / 2,
    center: (i: number) => r0 + i * step + step / 2,
  };
}

/** Un máximo «redondo» para el eje y su paso (1, 2, 2,5, 5 o 10 × 10ⁿ). */
export function niceMax(v: number, ticks = 4): { max: number; step: number } {
  if (!(v > 0)) return { max: ticks, step: 1 };
  const raw = v / ticks;
  const mag = 10 ** Math.floor(Math.log10(raw));
  const f = raw / mag;
  const step = (f <= 1 ? 1 : f <= 2 ? 2 : f <= 2.5 ? 2.5 : f <= 5 ? 5 : 10) * mag;
  return { max: Math.ceil(v / step) * step, step };
}

/** Las marcas del eje, de 0 al máximo, con su paso. */
export function ticks(max: number, step: number): number[] {
  const out: number[] = [];
  for (let v = 0; v <= max + step / 1000; v += step) out.push(Math.round(v * 1000) / 1000);
  return out;
}
